import Client from '../../lib/fetch/Client'
import * as URLUtils from '../../url'
import * as ObjectUtils from '../../object'

export default class IncidentsClient {
    constructor(base) {
        const url = URLUtils.buildPath(base, 'public', 'incidents')

        this.client = new Client(url)
    }
    getByID(id) {
        return this.client.get(id)
    }
    get(params = {}) {
        const query = new URLSearchParams(ObjectUtils.clean(params))
        const search = query.toString()
        const path = search ? '?' + search : null

        return this.client.get(path)
    }
}
